module.exports = __webpack_public_path__ + "files/705192c3f587177adae98962dc297c55.png";